/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.projects.WorkspaceNodeType
*/
export var WorkspaceNodeType;
(function (WorkspaceNodeType) {
    WorkspaceNodeType["FILE"] = "FILE";
    WorkspaceNodeType["DIR"] = "DIR";
})(WorkspaceNodeType || (WorkspaceNodeType = {}));
//# sourceMappingURL=WorkspaceNodeType.js.map